import React, { Component } from "react"
import * as tracking from "../../booking/helpers/tracking"
import config from "react-global-configuration"

class StepHeader extends Component {
  handleBackClick = () => {
    this.props.history.push({
      pathname: this.props.goBackPath.path,
      search: this.props.goBackPath.search || this.props.location.search,
    })
  }

  scrollToElement = (e) => {
    e.preventDefault()
    var el = document.getElementsByClassName("js--scroll-anchor")[0]
    var headerOffset = document.getElementsByClassName("section-header__inner")[0].offsetHeight
    var elementPosition = el.getBoundingClientRect().top
    var offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  trackClick = () => {
    tracking.trackParkingFlowClick("show all parking options", "", this.props)
  }

  handleClick = (e) => {
    console.log("failing at scroll?")
    this.scrollToElement(e)
    console.log("failing at track?")
    // this.trackClick()
  }

  render() {
    const textKeys = config.get("textKeys.stepHeader") || {}
    return (
      <section className={this.props.deck}>
        <div className="w--wider">
          <header className={`section-header section-header--slim ${this.props.modifier}`}>
            <div className="section-header__inner">
              <h2>{this.props.title}</h2>
              {this.props.isParkingListView && !this.props.useNewDesign ? (
                <nav className="section-header__inner__nav">
                  <p>
                    <a href="#parkingProductBrowser" onClick={(e) => this.handleClick(e)}>
                      {textKeys.seeAllParkingsText || "Se alle parkeringsmulighederne"}{" "}
                    </a>
                  </p>
                </nav>
              ) : null}
              {/* <nav className="section-header__inner__nav section-header__inner__nav--back">
                  <button 
                  onClick={this.handleBackClick}
                  className="button button--link has-icon rm-this-class rm-this-class-hide-default">
                    <span className="icon">
                      <svg className="svg-icon svg-icon--arrowleft">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowleft">&nbsp;</use>
                      </svg>				
                    </span>
                    <span className="text">{textKeys.back || "Tilbage til Parkering"}</span>
                  </button>		
                </nav> */}
            </div>
          </header>
        </div>
      </section>
    )
  }
}

export default StepHeader
